import Tooltip from "@/components/atoms/Tooltip/Tooltip";
import { useTranslation } from "@repo/shared/i18n";

export const EvoPopularity = ({ evoPopularity }: { evoPopularity: number }) => {
  const { t } = useTranslation("players");
  return (
    <Tooltip
      delayDuration={100}
      side="bottom"
      content={
        <div className="flex flex-col gap-y-1 max-w-44 text-xs">
          <h3 className="font-medium">{t("evoPopularity.title")}</h3>
          <p className="text-dark-secondary">
            {t("evoPopularity.description")}
          </p>
        </div>
      }
    >
      <div className="flex w-fit items-center gap-x-0.5">
        <EvoPopularityIcon />
        <span className="text-xs text-foreground-muted">{evoPopularity}</span>
      </div>
    </Tooltip>
  );
};

const EvoPopularityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.66634 9.66667C6.10837 9.66667 6.53229 9.49107 6.84485 9.17851C7.15741 8.86595 7.33301 8.44203 7.33301 8C7.33301 7.08 6.99967 6.66667 6.66634 6C5.95167 4.57133 6.51701 3.29733 7.99967 2C8.33301 3.66667 9.33301 5.26667 10.6663 6.33333C11.9997 7.4 12.6663 8.66667 12.6663 10C12.6663 10.6128 12.5456 11.2197 12.3111 11.7859C12.0766 12.352 11.7328 12.8665 11.2995 13.2998C10.8662 13.7332 10.3517 14.0769 9.78553 14.3114C9.21934 14.546 8.61251 14.6667 7.99967 14.6667C7.38684 14.6667 6.78 14.546 6.21382 14.3114C5.64763 14.0769 5.13318 13.7332 4.69984 13.2998C4.2665 12.8665 3.92276 12.352 3.68824 11.7859C3.45371 11.2197 3.33301 10.6128 3.33301 10C3.33301 9.23133 3.62167 8.47067 3.99967 8C3.99967 8.44203 4.17527 8.86595 4.48783 9.17851C4.80039 9.49107 5.22431 9.66667 5.66634 9.66667Z"
      fill="url(#paint0_linear_17398_32841)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_17398_32841"
        x1="7.99967"
        y1="2"
        x2="7.99967"
        y2="14.6667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EF4444" />
        <stop offset="1" stopColor="#F59E0B" />
      </linearGradient>
    </defs>
  </svg>
);
